import { render, staticRenderFns } from "./JobKeywords.vue?vue&type=template&id=395dacb6&"
import script from "./JobKeywords.vue?vue&type=script&lang=js&"
export * from "./JobKeywords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports